export interface ValidationRule {
  type: 'regex' | 'unique';
  regex?: RegExp;
  message: string;
  uniqueValidation? : (value: string) => Promise<boolean>;
  applyWhen?: (context: any) => boolean; // New property to conditionally apply rules
}

export const validateField = async (
  name: string,
  value: string,
  rules: { [key: string]: ValidationRule[] }
): Promise<string> => {
  const ruleVal = rules[name];
  for (const rule of ruleVal || []) {
    // Check if the rule should be applied based on the applyWhen function
    const shouldApply = rule.applyWhen ? rule.applyWhen({ [name]: value }) : true;

    if (shouldApply) {
      if (rule.type === 'regex' && rule.regex && !rule.regex.test(value)) {
        return rule.message;
      }

      if (rule.type === 'unique' && rule.uniqueValidation) {
        const isUnique = await rule.uniqueValidation(value);
        if (!isUnique) {
          return rule.message;
        }
      }
    }
  }
  return '';
};

export const validateAllFields =  async (
  item: Record<string, any>,
  rules: { [key: string]: ValidationRule[] }
): Promise<{ [key: string]: string; }> => {
  const errors: { [key: string]: string } = {};
  await Promise.all(
    Object.keys(item).map(async (key) => {
      const errorMessage = await validateField(key, item[key], rules);
      if (errorMessage) {
        errors[key] = errorMessage;
      }
    })
  );
  return errors;
};
